export default __webpack_public_path__ + "static/media/login-bg-36.30d90c97.jpg";